import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaRb010 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        coursePlan: string[]
      }
    }

    // API Response
    export interface Response {
      labCategory: {
        labCategoryId: string
        labCategoryDispName: string
        labPanelArray: {
          labPanelId: string
          labPanelDispName: string
          imageUrl: string
          contentUrl: string
          description: string
        }[]
      }[]
    }
  }

  // API Path
  const path: string = '/ta/learnTrainingLabs'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        labCategory: [
          {
            labCategoryId: '',
            labCategoryDispName: '',
            labPanelArray: [
              {
                labPanelId: '',
                labPanelDispName: '',
                imageUrl: '',
                contentUrl: '',
                description: '',
              },
            ],
          },
        ],
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
